<div
  class="con"
  [ngClass]="{
    container: isMoveTree
  }"
>
  <ion-searchbar
    *ngIf="!isMoveTree"
    placeholder="Elemente durchsuchen"
    show-clear-button="focus"
    [ngModel]="searchTerm$ | async"
    (ngModelChange)="setSearchTerm($event)"
  ></ion-searchbar>
  <div style="width: 100%; display: flex; justify-content: space-between">
    <ion-breadcrumbs style="width: 100%">
      <ion-breadcrumb
        style="cursor: pointer"
        (click)="goToBreadcrumb(node)"
        *ngFor="let node of breadcrumbs"
        >{{ node.displayName }}</ion-breadcrumb
      >
    </ion-breadcrumbs>
  </div>

  <div class="doc-list">
    <div class="sort-info-section">
      <div *ngIf="breadcrumbs.length == 1 && !(searchTerm$ | async)">
        {{ (this.currentItems$ | async)?.length }} {{ ALLITEMS }} gefunden
      </div>
      <div *ngIf="breadcrumbs.length > 1">
        {{ (this.currentItems$ | async)?.length }} Ergebnisse
      </div>
      <div
        *ngIf="
          breadcrumbs.length == 1 &&
          (currentFolderId$ | async) == this.state.magicNumber &&
          (searchTerm$ | async)
        "
      >
        {{ (this.currentItems$ | async)?.length }} Ergebnisse in allen
        {{ ALLITEMS }}
      </div>
      @if(showFilters){
      <div style="display: flex; align-items: center">
        @if((currentFolderId$ | async) == state.magicNumber && conSitesMode){
        <ion-select
          style="width: 120px"
          [value]="0"
          (ionChange)="selectedStateChange($event.detail.value)"
          label="Baustellenstatus"
          label-placement="floating"
          interface="action-sheet"
          cancelText="Abbruch"
        >
          <ion-select-option
            *ngFor="let val of constructionSiteStates"
            [value]="val.value"
          >
            {{ val.label }}</ion-select-option
          >
        </ion-select>
        }
        <ion-select
          style="width: 160px; margin-left: 10px"
          label="Sortierung"
          label-placement="floating"
          (ionChange)="sortChange($event)"
          interface="action-sheet"
          [value]="selectedSortOption.value?.label"
          cancelText="Abbruch"
        >
          <ion-select-option
            *ngFor="let sortOption of this.sortOptions"
            [value]="sortOption.label"
            >{{ sortOption.label }}</ion-select-option
          >
        </ion-select>
      </div>
      } @if(!state.isBigScreen){
      <ion-icon
        (click)="showFilters = !showFilters"
        style="font-size: 24px"
        name="funnel-outline"
      ></ion-icon>
      }
    </div>
  </div>
  <div
    class="custom-table"
    [ngClass]="{
      'custom-table-move': isMoveTree,
      'custom-table-basic': !isMoveTree && state.isBigScreen,
      'custom-table-basic-mobile': !isMoveTree && !state.isBigScreen
    }"
  >
    <div class="row header">
      <div
        class="col"
        style="display: flex; align-items: center"
        *ngIf="!isMoveTree"
      >
        <ion-checkbox
          [checked]="allSelected"
          (ionChange)="toggleAll()"
          (click)="$event.stopPropagation()"
          [disabled]="!state.userHasMinType(1)"
        ></ion-checkbox>
      </div>
      <div class="col">
        @if(breadcrumbs.length != 1 || !conSitesMode){
        <ion-icon name="folder-outline"></ion-icon>
        }@else{
        <ion-icon name="construct-outline"></ion-icon>
        }
      </div>
      <div class="col grow">Name</div>
      <div class="col" *ngIf="!isMoveTree && state.isBigScreen">Elemente</div>
      <div class="col" *ngIf="!isMoveTree && state.isBigScreen">Datum</div>

      <!--div class="col">Geändert</div-->
    </div>

    <div
      class="row"
      *ngFor="let doc of currentItems$ | async"
      [ngClass]="{ disabled: itemsToMove.includes(doc) }"
    >
      <div class="col" *ngIf="!isMoveTree">
        <ion-checkbox
          [checked]="isSelected(doc)"
          (click)="$event.stopPropagation()"
          (ionChange)="toggleSelection(doc)"
          [disabled]="!state.userHasMinType(1)"
        ></ion-checkbox>
      </div>
      <div class="col" (click)="itemClicked(doc)">
        <ion-icon [name]="getIcon(doc)"></ion-icon>
      </div>

      <div class="col grow" (click)="itemClicked(doc)">
        {{ doc.displayName }}
      </div>
      @if(!isMoveTree && state.isBigScreen){
      <div class="col" (click)="itemClicked(doc)">
        @if(doc.fileExtension){ - } @else{ {{ doc.childrenCount }} }
      </div>
      } @if(!isMoveTree && state.isBigScreen){
      <div class="col">{{ doc.createdUtc | date : "dd.MM.yyyy" }}</div>
      }
    </div>
    <!--div
      class="row"
      *ngIf="(currentItems$ | async)?.length == 0 && breadcrumbs.length > 1"
      (click)="goBack()"
    >
      <div class="col">
        <ion-icon
          style="font-size: 18px; color: white"
          *ngIf="breadcrumbs.length <= 1"
          name="square-outline"
        ></ion-icon>
      </div>
      <div class="col"><ion-icon name="arrow-undo-outline"></ion-icon></div>
      <div class="col grow">Zurück</div>
    </div-->
  </div>
</div>
